import {
	UPDATE_PAGE,
	OPEN_LOGIN_BOX,
	LOGIN_ERROR,
	LOGIN,
	INIT_DB,
	GO_ONLINE,
	GO_OFFLINE,
	LOGOUT,
	CLOSE_DB
} from "../actions/app.js";

const app = (
	state = {
		route: { page: null, id: null, subpage: null },
		openLoginBox: localStorage.token == undefined,
		token: localStorage.token,
		username: localStorage.username,
		lud: localStorage.lud,
		online: false,
		dbName: "",
		dbReady: false,
		loginError: ""
	},
	action
) => {
	switch (action.type) {
		case UPDATE_PAGE:
			return {
				...state,
				route: action.route
			};

		case OPEN_LOGIN_BOX:
			localStorage.token = "";
			return {
				...state,
				openLoginBox: true,
				token: "",
			};

		case LOGIN:
			localStorage.token = action.data.token;
			localStorage.username = action.username;
			localStorage.profile = JSON.stringify(action.data.profile)
			return {
				...state,
				openLoginBox: false,
				token: action.data.token,
				username: action.username,
				loginError: ""
			};

		case LOGIN_ERROR:
			return {
				...state,
				openLoginBox: true,
				loginError: action.error
			};

		case LOGOUT:
			localStorage.token = "";
			localStorage.username = "";
			return {
				...state,
				openLoginBox: true,
				token: "",
				loginError: ""
			};

		case INIT_DB:
			return {
				...state,
				dbName: action.dbName,
				dbReady: true
			};

		case CLOSE_DB:
			return {
				...state,
				dbName: "",
				dbReady: false
			};

		case GO_ONLINE:
			return {
				...state,
				online: true
			};

		case GO_OFFLINE:
			return {
				...state,
				online: false
			};

		default:
			return state;
	}
};

export default app;
